import McBasicForm from './McBasicForm';

export default McBasicForm;
